/* eslint-disable */

/**
 * Disabling ESLint because there is a bad import in here of DocketSearchifyFLV. It's
 * unclear if this is dead code, as tracing it leads to several files, but this is all
 * in the "search" folder, not "search-new". If it were breaking something, or in use,
 * or updated, we likely would've run into this issue sooner.
 *
 * If you're coming across this message and some time has passed, consider cleaning up
 * the code tracking down if this is used at all and if not, delete it.
 */
import React from "react"
import PropTypes from "prop-types"

import { federalRegions } from "shared/imports/regionConstants"

import { DateListNoFutureSelect } from "app/static/frontend/selects/containers/EnumSelect"
import {
    DocketSelect,
    RegulationSelect,
    RegulationDocumentSelect,
} from "app/static/frontend/selects/containers/PieSelect"

import {
    DocketSearchifyFLV,
    RegulationFilterableListView,
    RegulationDocumentFilterableListView,
} from "shared/search/containers/FilterableListView/FilterableListViews"

import {
    datePickerGenericFilter,
    enumSingleGenericFilter,
    enumOrderSort,
    textGenericFilter,
} from "shared/search/containers/Filter/Filters"
import {
    enumGenericFilter,
    searchifySelectGenericFilter,
    toggleGenericFilter,
} from "shared/search/containers/Filter/FilterCreators"

const defaultPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    dataTypeLabel: PropTypes.string,
    helpText: PropTypes.string,
    invisible: PropTypes.bool,
    selectComponent: PropTypes.func,
    regions: PropTypes.array,
    placeholderText: PropTypes.string,
    trueText: PropTypes.string,
    falseText: PropTypes.string,
}

const defaultEnumPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    enumItems: PropTypes.array,
    helpText: PropTypes.string,
    sortBy: PropTypes.func,
}

const dateDefaultPropTypes = {
    displayLabel: PropTypes.string,
    filterComponent: PropTypes.func,
    filterKey: PropTypes.string,
    uniqueFilterId: PropTypes.string,

    noFuture: PropTypes.bool,
}

/** Type */
export const RegulationCommentSourceTypeFilter = (props) => {
    const FilterComponent = props.filterComponent || enumGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentSourceTypeFilter.propTypes = defaultEnumPropTypes
RegulationCommentSourceTypeFilter.defaultProps = {
    filterComponent: enumGenericFilter,
    uniqueFilterId: "typeFilter",
    filterKey: "source_type__in",
    enumItems: DjangIO.app.reg.types.RegCommentSourceType.region_supported_items(),
    sortBy: enumOrderSort,
    displayLabel: "Comment Type",
}

// created date filters
export const RegulationCommentDateListNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || enumSingleGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentDateListNoFutureFilter.propTypes = defaultEnumPropTypes
RegulationCommentDateListNoFutureFilter.defaultProps = {
    filterComponent: enumSingleGenericFilter,
    uniqueFilterId: "regulationCommentDateListNoFutureFilter",
    filterKey: "date_range",
    enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
        (item) =>
            ![
                DjangIO.app.events.models.DateRangeType.future.value,
                DjangIO.app.events.models.DateRangeType.next_month.value,
                DjangIO.app.events.models.DateRangeType.next_week.value,
            ].includes(item.value),
    ),
    sortBy: enumOrderSort,
    displayLabel: "Date Created",
    helpText:
        "Filter for results that were added to Quorum after a particular date " + "or within a specific date range.",
    selectComponent: DateListNoFutureSelect,
}

export const RegulationCommentDatePickerStartNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentDatePickerStartNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationCommentDatePickerStartNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationCommentDatePickerStartNoFutureFilter",
    filterKey: "created__gt",
    displayLabel: "Start Date",
    noFuture: true,
}

export const RegulationCommentDatePickerEndNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentDatePickerEndNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationCommentDatePickerEndNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationCommentDatePickerEndNoFutureFilter",
    filterKey: "created__lt",
    displayLabel: "End Date",
    noFuture: true,
}

export const RegulationCommentDateReceivedByAgencyNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || enumSingleGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentDateReceivedByAgencyNoFutureFilter.propTypes = defaultEnumPropTypes
RegulationCommentDateReceivedByAgencyNoFutureFilter.defaultProps = {
    filterComponent: enumSingleGenericFilter,
    uniqueFilterId: "regulationCommentDateReceivedByAgencyNoFutureFilter",
    filterKey: "date_range_received_by_agency",
    enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
        (item) =>
            ![
                DjangIO.app.events.models.DateRangeType.future.value,
                DjangIO.app.events.models.DateRangeType.next_month.value,
                DjangIO.app.events.models.DateRangeType.next_week.value,
            ].includes(item.value),
    ),
    sortBy: enumOrderSort,
    displayLabel: "Date Received by Agency",
    helpText:
        "Filter for results that were Received by the Agency after a particular date " +
        "or within a specific date range.",
}

export const RegulationCommentDateReceivedByAgencyPickerStartNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentDateReceivedByAgencyPickerStartNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationCommentDateReceivedByAgencyPickerStartNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationCommentDateReceivedByAgencyPickerStartNoFutureFilter",
    filterKey: "received_by_agency_datetime__gt",
    displayLabel: "Start Date Received by Agency",
    noFuture: true,
}

export const RegulationCommentDateReceivedByAgencyPickerEndNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentDateReceivedByAgencyPickerEndNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationCommentDateReceivedByAgencyPickerEndNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationCommentDateReceivedByAgencyPickerEndNoFutureFilter",
    filterKey: "received_by_agency_datetime__lt",
    displayLabel: "End Date Received by Agency",
    noFuture: true,
}

export const RegulationCommentDatePostedByAgencyNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || enumSingleGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentDatePostedByAgencyNoFutureFilter.propTypes = defaultEnumPropTypes
RegulationCommentDatePostedByAgencyNoFutureFilter.defaultProps = {
    filterComponent: enumSingleGenericFilter,
    uniqueFilterId: "regulationCommentDatePostedByAgencyNoFutureFilter",
    filterKey: "date_range_posted_by_agency",
    enumItems: DjangIO.app.events.models.DateRangeType.region_supported_items().filter(
        (item) =>
            ![
                DjangIO.app.events.models.DateRangeType.future.value,
                DjangIO.app.events.models.DateRangeType.next_month.value,
                DjangIO.app.events.models.DateRangeType.next_week.value,
            ].includes(item.value),
    ),
    sortBy: enumOrderSort,
    displayLabel: "Date Posted by Agency",
    helpText:
        "Filter for results that were Posted by the Agency after a particular date " +
        "or within a specific date range.",
}

export const RegulationCommentDatePostedByAgencyPickerStartNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentDatePostedByAgencyPickerStartNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationCommentDatePostedByAgencyPickerStartNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationCommentDatePostedByAgencyPickerStartNoFutureFilter",
    filterKey: "posted_by_agency_datetime__gt",
    displayLabel: "Start Date Posted by Agency",
    noFuture: true,
}

export const RegulationCommentDatePostedByAgencyPickerEndNoFutureFilter = (props) => {
    const FilterComponent = props.filterComponent || datePickerGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentDatePostedByAgencyPickerEndNoFutureFilter.propTypes = dateDefaultPropTypes
RegulationCommentDatePostedByAgencyPickerEndNoFutureFilter.defaultProps = {
    filterComponent: datePickerGenericFilter,
    uniqueFilterId: "regulationCommentDatePostedByAgencyPickerEndNoFutureFilter",
    filterKey: "posted_by_agency_datetime__lt",
    displayLabel: "End Date Posted by Agency",
    noFuture: true,
}

// searchify
export const RegulationCommentDocketSourceFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={DocketSearchifyFLV} {...props} />
}
RegulationCommentDocketSourceFilter.propTypes = defaultPropTypes
RegulationCommentDocketSourceFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "regulationCommentDocketSourceFilter",
    filterKey: "comment_on_docket",
    dataTypeLabel: "Docket(s)",
    displayLabel: "Docket(s)",
    selectComponent: DocketSelect,
    regions: federalRegions,
}

export const RegulationCommentRegulationSourceFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={RegulationFilterableListView} {...props} />
}
RegulationCommentRegulationSourceFilter.propTypes = defaultPropTypes
RegulationCommentRegulationSourceFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "regulationCommentRegulationSourceFilter",
    filterKey: "comment_on_regulation",
    dataTypeLabel: "Regulation(s)",
    displayLabel: "Regulation(s)",
    selectComponent: RegulationSelect,
    regions: federalRegions,
}

export const RegulationCommentRegulationDocumentSourceFilter = (props) => {
    const FilterComponent = props.filterComponent || searchifySelectGenericFilter
    return <FilterComponent searchifyFLV={RegulationDocumentFilterableListView} {...props} />
}
RegulationCommentRegulationDocumentSourceFilter.propTypes = defaultPropTypes
RegulationCommentRegulationDocumentSourceFilter.defaultProps = {
    filterComponent: searchifySelectGenericFilter,
    uniqueFilterId: "regulationCommentRegulationDocumentSourceFilter",
    filterKey: "comment_on_document",
    dataTypeLabel: "Regulation Document(s)",
    displayLabel: "Regulation Document(s)",
    selectComponent: RegulationDocumentSelect,
    regions: federalRegions,
}

// text
export const RegulationCommentTitleFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentTitleFilter.propTypes = defaultPropTypes
RegulationCommentTitleFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "regulationCommentTitleFilter",
    filterKey: "title_search",
    placeholderText: "Search text of Regulation Comment title(s)...",
    displayLabel: "Search Title(s)",
}

export const RegulationCommentAuthorFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentAuthorFilter.propTypes = defaultPropTypes
RegulationCommentAuthorFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "regulationCommentAuthorFilter",
    filterKey: "commenter_name_search",
    placeholderText: "Search text of Regulation Comment author(s)...",
    displayLabel: "Search Author(s)",
}

export const RegulationCommentOrganizationFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentOrganizationFilter.propTypes = defaultPropTypes
RegulationCommentOrganizationFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "regulationCommentOrganizationFilter",
    filterKey: "organization_name_search",
    placeholderText: "Search text of Regulation Comment organization(s)...",
    displayLabel: "Search Organization(s)",
}

export const RegulationCommentCategoryFilter = (props) => {
    const FilterComponent = props.filterComponent || textGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentCategoryFilter.propTypes = defaultPropTypes
RegulationCommentCategoryFilter.defaultProps = {
    filterComponent: textGenericFilter,
    uniqueFilterId: "regulationCommentCategoryFilter",
    filterKey: "category_search",
    placeholderText: "Search text of Regulation Comment categories...",
    displayLabel: "Search Categories",
}

// toggles
export const RegulationCommentAnonymousFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentAnonymousFilter.propTypes = defaultPropTypes
RegulationCommentAnonymousFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "regulationCommentAnonymousFilter",
    filterKey: "hide_anonymous_comments",
    displayLabel: "Anonymous Comments",
    trueText: "Show",
    falseText: "Hide",
    helpText: "Show or hide comments that were made anonymously.",
}

export const RegulationCommentSourceFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentSourceFilter.propTypes = defaultPropTypes
RegulationCommentSourceFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "regulationCommentSourceFilter",
    filterKey: "author_or_org",
    displayLabel: "Source",
    trueText: "Individual",
    falseText: "Organization",
    helpText: "Display comments by the type of their author.",
}

export const RegulationCommentAttachmentFilter = (props) => {
    const FilterComponent = props.filterComponent || toggleGenericFilter
    return <FilterComponent {...props} />
}
RegulationCommentAttachmentFilter.propTypes = defaultPropTypes
RegulationCommentAttachmentFilter.defaultProps = {
    filterComponent: toggleGenericFilter,
    uniqueFilterId: "regulationCommentAttachmentFilter",
    filterKey: "has_attachment",
    displayLabel: "Attachments",
    trueText: "Yes",
    falseText: "No",
    helpText: "Display comments by whether or not they have files attached.",
}
